'use client';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useAccount, useDisconnect } from 'wagmi';

export function WalletAuthHandler() {
  const { disconnect } = useDisconnect();
  const { isConnected } = useAccount();

  useEffect(() => {
    const handleAuthError = () => {
      if (isConnected && !document.cookie.includes('auth_token')) {
        disconnect();
        toast.error('Please reconnect your wallet', {
          toastId: 'wallet-auth-error',
        });
      }
    };

    window.addEventListener('walletAuthError', handleAuthError);
    return () => window.removeEventListener('walletAuthError', handleAuthError);
  }, [disconnect, isConnected]);

  return null;
}
